import React from 'react';
import { MaterialUiCore } from '@gscope-mfe/common-libs';
import { useHistory } from 'react-router-dom';
import emptyPinArea from '../../images/emptyPinArea.png';
import { AppUtils } from '@gscope-mfe/app-bridge';
import styles from './PinnedPanel.module.css';
import { useTranslation } from 'react-i18next';
const { Grid, Modal, Box, Button } = MaterialUiCore;
const PinnedPanel = ({ pinnedBuckets, unpin, showPanelWithChild, nested = false }) => {
    let history = useHistory();
    const [unpinClicked, setUnpinClicked] = React.useState(false);
    const [unpinBucket, setUnpinBucket] = React.useState({});
    const [unpinClearFlag, setUnpinClearFlag] = React.useState(false);
    const { headerConfig } = AppUtils.get();
    const { t } = useTranslation('commonLang');

    const navigateToPage = (route) => {
        if (history.location.pathname != route) history.push(route);
    };
    const UnpinConfirmAndAct = (bucket, flag = false) => {
        setUnpinClicked(true);
        setUnpinBucket(bucket);
        setUnpinClearFlag(flag);
    };

    const unpinHandler = () => {
        unpin(unpinBucket, unpinClearFlag);
        setUnpinClicked(false);
        setUnpinBucket({});
        setUnpinClearFlag(false);
    };

    const unpinCancelHandler = () => {
        setUnpinClicked(false);
        setUnpinBucket({});
        setUnpinClearFlag(false);
    };
    const handleModalClick = (e) => {
        e.stopPropagation();
        e.preventDefault();
    };
    return (
        <Grid data-testid="pinned-modules" className={styles.pinnedPanel}>
            {Object.keys(pinnedBuckets).length > 0 &&
                Object.keys(pinnedBuckets)
                    .sort((a, b) => {
                        if (pinnedBuckets[a].name < pinnedBuckets[b].name) {
                            return -1;
                        }
                        if (pinnedBuckets[a].name > pinnedBuckets[b].name) {
                            return 1;
                        }
                    })
                    .map((bucket, index) => {
                        return (
                            <Grid key={index}>
                                <div
                                    style={nested ? { paddingLeft: '45px' } : {}}
                                    data-testid="all-buckets-pin"
                                    className={styles['bucket-item']}
                                >
                                    {pinnedBuckets[bucket]['pinned'] ? (
                                        <i
                                            className={'sct-icon icon-2111_unpinLatest ' + `${styles['page-icon']}`}
                                            data-testid="icon-bucket-pinned-true"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                UnpinConfirmAndAct(pinnedBuckets[bucket], false);
                                            }}
                                        />
                                    ) : (
                                        <i
                                            className={'sct-icon icon-2111_unpinLatest ' + `${styles['page-icon']}`}
                                            data-testid="icon-bucket-pinned-false"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                UnpinConfirmAndAct(pinnedBuckets[bucket], true);
                                            }}
                                        />
                                    )}
                                    <span
                                        className={
                                            !pinnedBuckets[bucket]['pinned']
                                                ? styles['bucket-text-without-pin']
                                                : styles['bucket-text']
                                        }
                                        style={
                                            headerConfig.windowWidth <= 425
                                                ? !nested
                                                    ? { fontWeight: 'bold' }
                                                    : { fontWeight: '500' }
                                                : nested
                                                ? { fontWeight: '500' }
                                                : { fontWeight: 'bold' }
                                        }
                                    >
                                        {t(bucket) == bucket ? pinnedBuckets[bucket].name : t(bucket)}
                                    </span>
                                </div>
                                {pinnedBuckets[bucket].pages &&
                                    Object.keys(pinnedBuckets[bucket].pages)
                                        .sort((a, b) => {
                                            if (
                                                pinnedBuckets[bucket].pages[a].name <
                                                pinnedBuckets[bucket].pages[b].name
                                            ) {
                                                return -1;
                                            }
                                            if (
                                                pinnedBuckets[bucket].pages[a].name >
                                                pinnedBuckets[bucket].pages[b].name
                                            ) {
                                                return 1;
                                            }
                                        })
                                        .map((page, ind) => {
                                            if (
                                                Object.prototype.hasOwnProperty.call(
                                                    pinnedBuckets[bucket].pages[page],
                                                    'route',
                                                )
                                            )
                                                return (
                                                    <div
                                                        key={ind}
                                                        data-testid="module-pin"
                                                        onClick={() =>
                                                            navigateToPage(pinnedBuckets[bucket].pages[page].route)
                                                        }
                                                        className={`${styles['nav-item']}`}
                                                        style={
                                                            nested
                                                                ? headerConfig.windowWidth <= 425
                                                                    ? { paddingLeft: '80px' }
                                                                    : { paddingLeft: '78px' }
                                                                : {}
                                                        }
                                                    >
                                                        {pinnedBuckets[bucket].pages[page]['pinned'] ? (
                                                            <i
                                                                data-testid="icon-pinned-module"
                                                                className={
                                                                    'sct-icon icon-2111_unpinLatest ' +
                                                                    `${styles['page-icon']}`
                                                                }
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    UnpinConfirmAndAct(
                                                                        pinnedBuckets[bucket].pages[page],
                                                                    );
                                                                }}
                                                            />
                                                        ) : (
                                                            ''
                                                        )}
                                                        <span
                                                            style={
                                                                nested
                                                                    ? { fontWeight: 'normal' }
                                                                    : { fontWeight: '500' }
                                                            }
                                                            className={styles['item-text']}
                                                        >
                                                            {t(pinnedBuckets[bucket].pages[page].navKey) ==
                                                            pinnedBuckets[bucket].pages[page].navKey
                                                                ? pinnedBuckets[bucket].pages[page].name
                                                                : t(pinnedBuckets[bucket].pages[page].navKey)}
                                                        </span>
                                                    </div>
                                                );
                                            else
                                                return (
                                                    <div key={ind} data-testid="nested-pin">
                                                        <PinnedPanel
                                                            pinnedBuckets={{
                                                                [page]: pinnedBuckets[bucket].pages[page],
                                                            }}
                                                            unpin={unpin}
                                                            showPanelWithChild={showPanelWithChild}
                                                            nested={true}
                                                        />
                                                    </div>
                                                );
                                        })}
                                {!nested ? <hr /> : ''}
                            </Grid>
                        );
                    })}

            {unpinClicked && (
                <Modal
                    open={unpinClicked}
                    onClose={unpinCancelHandler}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                    style={{ top: '40%' }}
                    data-testid="unpin-modal"
                    className={styles.modal}
                    onClick={handleModalClick}
                >
                    <Box
                        className={styles.modalUnpin}
                        sx={{ background: 'white', width: '100%', padding: '10px', borderRadius: '8px' }}
                    >
                        <h4 id="child-modal-title" style={{ fontWeight: 'bold' }}>
                            {t('confirmUnpinning')}
                        </h4>
                        <hr style={{ width: '100%', height: '1px', paddingBottom: '0px' }}></hr>
                        <div id="child-modal-description" className={styles.description}>
                            <p id="child-modal-description">
                                {t('unPinningPromptSingle')} <b>{unpinBucket.name}</b>?
                            </p>
                        </div>
                        <hr style={{ width: '100%', height: '1px' }}></hr>
                        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <Button
                                data-testid="my-unpin-cancel"
                                className={styles.unpinCancel}
                                onClick={unpinCancelHandler}
                            >
                                {t('cancel')}
                            </Button>
                            <Button
                                data-testid="my-unpin-button"
                                variant="contained"
                                className={styles.unpinButton}
                                onClick={(e) => {
                                    unpinHandler(e);
                                }}
                            >
                                {t('yes')}
                            </Button>
                        </div>
                    </Box>
                </Modal>
            )}

            {Object.keys(pinnedBuckets).length == 0 && (
                <div data-testid="emptyPin">
                    <img style={{ padding: '10px' }} src={emptyPinArea} alt="Empty Pin Area" />
                    <h3>{t('noPinnedItems')}</h3>
                    <span>{t('noPinnedItemsText')}</span>
                </div>
            )}
        </Grid>
    );
};
export default PinnedPanel;
